// extracted by mini-css-extract-plugin
export var standaloneTable = "_u-0";
export var standaloneTableWithBodyFill = "_u-1";
export var withExtraHeader = "_u-2";